import { gql } from '@apollo/client';

const CREATE_LOGIN_SUCCESS_EVENT = gql`
  mutation createLoginSuccessEvent($data: LoginSuccessEventCreateInput!) {
    createLoginSuccessEvent(data: $data)
  }
`;
export default CREATE_LOGIN_SUCCESS_EVENT;
